import { render, staticRenderFns } from "./ContractsDebt.vue?vue&type=template&id=25038d9d&"
import script from "./ContractsDebt.vue?vue&type=script&lang=js&"
export * from "./ContractsDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports